import * as React from "react";
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogTrigger,
  DialogBody,
  Button,
  useRestoreFocusTarget,
  Radio,
  RadioGroup,
  Spinner,
} from "@fluentui/react-components";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import moment from "moment";
import ASCButton from "../../../components/Button";
import apiServices from "../../../service";
import { formatedDate, isObjectEmpty } from "../../../utils";
import DynamicDatePicker from "../../../components/ControlledDatePicker/dynamicDatepicker";

export const StopReceiptPopUp = ({
  openModal,
  setStopReceiptPopup,
  setStopReceiptpopup,
  selectedItem,
  notify,
  getCommissionDataList,
}: any) => {
  const closePopup =
    setStopReceiptPopup ?? setStopReceiptpopup ?? (() => { });
  const [selected, setSelected] = React.useState("");
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
  const [stopDate, setStopDate] = React.useState<Date | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [dataLoading, setDataLoading] = React.useState(false);
  const [lastDueDate, setLastDueDate] = React.useState<Date | null>(null);
  const [nextDueDate, setNextDueDate] = React.useState<Date | null>(null);
  const onSelectDate = (date: Date | null | undefined) => {
    setSelectedDate(date ?? null);
    setStopDate(date ?? null);
  };

  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(date).format("DD-MM-YYYY");
  };
  React.useEffect(() => {
    getCommissionDetails();
  }, [selectedItem]);
  const getCommissionDetails = () => {
    if (
      selectedItem !== null &&
      selectedItem !== undefined &&
      !isObjectEmpty(selectedItem) &&
      selectedItem?.commission_id
    ) {
      setDataLoading(true);
      apiServices.commission
        .getDetails(selectedItem.commission_id)
        .then((response: any) => {
          setDataLoading(false);
          if (response.data.isError) {
          } else {
            setLastDueDate(response.data?.data?.mostRecentReceiptDate || null);
            setNextDueDate(response.data?.data?.nextReceiptDate || null);
          }
        })
        .catch((err: any) => {
          console.log(err);
          notify(err.message, "", "error");
          setDataLoading(false);
        });
    }
  };
  const handleStopReceipts = () => {
    if (
      stopDate != null && selectedItem?.commission_id
    ) {
      setLoading(true);
      apiServices.commission
        .stopReceipt(selectedItem.commission_id, {
          stop_date: stopDate,
        })
        .then(async (response: any) => {
          setLoading(false);
          if (response.data.isError) {
            // Show error message as toast
            const errorMsg =
              response.data.error?.message?.[0] ||
              response.data.error?.message ||
              "Something went wrong";

            notify(errorMsg, "", "error");
          } else {
            notify(response.data.message, "", "success");
            if (getCommissionDataList) {
              await getCommissionDataList();
            }
            setTimeout(() => {
              closePopup(false);
            }, 2000);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          notify(err.message, "", "error");
        });
    }
  };

  return (
    <>
      <Dialog
        // this controls the dialog open state
        open={openModal}
        onOpenChange={(event, data) => {
          closePopup(data.open);
        }}
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle>
              <span style={{ marginLeft: "8px" }}>
                Stop Commission Receipts
              </span>
            </DialogTitle>
            <DialogContent>
              <div style={{ marginLeft: "8px" }}>
                <p>
                  {" "}
                  Please enter a date when the last receipt is expected to be
                  received
                </p>
              </div>
              <div
                style={{
                  marginTop: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  marginLeft: "8px",
                }}
              >
                <p>
                  {" "}
                  Last Due Date Receipted :{" "}
                  <span>{lastDueDate ? onFormatDate(lastDueDate) : ""}</span>
                </p>
                <p>
                  {" "}
                  Next Due Date to be received :{" "}
                  <span>{nextDueDate ? onFormatDate(nextDueDate) : ""}</span>
                </p>
              </div>
              <RadioGroup
                value={selected}
                onChange={(_, data) => {
                  setSelected(data.value);
                  if (data.value !== "customDate") {
                    setSelectedDate(null);
                    setStopDate(lastDueDate);
                  }
                }}
                style={{
                  marginTop: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "2px" }}
                >
                  <Radio value="lastDate" label="" />
                  <span>Stop all receipts after Last Due Date Receipted</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "2px" }}
                >
                  <Radio value="customDate" label="" />
                  <span style={{ marginRight: "4px" }}>
                    Stop all receipts after this date:
                  </span>
                  <DynamicDatePicker
                    border
                    name="custom_date"
                    label={null}
                    required={false}
                    disabled={selected !== "customDate"}
                    formik={{
                      values: {
                        custom_date: selectedDate,
                      },
                      setFieldValue: (_name: string, value: any) => {
                        onSelectDate(value);
                      },
                      setFieldTouched: () => { },
                      setFieldError: () => { },
                      errors: {},
                      touched: {},
                    }}
                  />
                </div>
              </RadioGroup>
            </DialogContent>

            <DialogActions style={{ marginTop: "14px" }}>
              <ASCButton
                className="asc-button-primary"
                shape="rounded"
                appearance="primary"
                label={loading ? "Processing" : "Save"}
                icon={loading ? <Spinner size="tiny" /> : null}
                onClick={() => {
                  handleStopReceipts();
                }}
                disabled={stopDate == null || loading}
              />
              {/* DialogTrigger inside of a Dialog still works properly */}
              <DialogTrigger disableButtonEnhancement>
                <ASCButton
                  onClick={() => closePopup(false)}
                  shape="rounded"
                  appearance="secondary"
                  label="Cancel"
                />
              </DialogTrigger>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
};
